// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumBadge-cls1_TsR","cls2":"PremiumBadge-cls2_BnT PremiumBadge-cls1_TsR"};